<template>
    <div id="about">
        <!-- section title -->
        <h1>About Me</h1>
        <!-- avatar -->
        <div class="avatar">
            <!-- signature -->
            <img class="signature" src="../../assets/img/signature.png">
        </div>
        <!-- content -->
        <div class="content-container">
            <!-- description -->
            <h3>Keep on going never give up.</h3>
            <!-- summary -->
            <p>I'm an undergraduate, studying computer science at the Chinese University of Hong Kong. I self-learned front-end in the last two summer semesters, and this webpage is a conclusion and exhibition of my learning result, hope you enjoy my design. I am going to learn Python and TensorFlow in the following semester, and I also want to learn Django for developing websites; I hope I have enough time, lol. I still haven't planned my development direction; I am interested in both AI and back-end, but as a priority, I hope to find an internship in front-end development in the coming year to enrich my working experience.</p>
        </div>
        <!-- resume button -->
        <div class="resume" @click="$store.commit('GO_STATIC', 'cv.pdf')">Resume</div>
    </div>
</template>

<script>
export default {
    name:'About',
}
</script>

<style scoped>
#about{
    height: 650px;
    background-image: url(../../assets/background/future.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    color: aliceblue;
}


/* section title styles */
h1{
    height: 80px;
    font-size: 40px;
    line-height: 80px;
    font-family: "Snell Roundhand", "cursive";
    font-weight: bolder;
}


/* avatar style */
.avatar{
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin: 20px auto;
    background-color: aliceblue;
    background-image: url(../../assets/img/avatar.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    position: relative;
}


/* signature style */
.signature{
    position: absolute;
    top: -50px;
    left: 180px;
    height: 150px;
    transform: rotate(15deg);
}


/* The content-container styles */
.content-container{
    width: 1000px;
    height: 250px;
    margin: 0 auto;
}
/* description */
.content-container h3{
    font: 30px bold;
    line-height: 2;
    font-family: "Brush Script MT", "Brush Script Std", "cursive";
}
/* summary */
.content-container p{
    text-align: left;
    font-size: 18px;
    line-height: 2;
}


/* resume button styles */
.resume{
    display: block;
    width: fit-content;
    height: 45px;
    padding: 0 20px;
    margin: 0 auto;
    border: transparent 1px solid;
    font-size: 20px;
    line-height: 45px;
    color: aliceblue;
    text-decoration: none;
    cursor: pointer;
}
.resume:hover{
    border: rgb(127, 129, 255) 1px solid;
    color: rgb(127, 129, 255);
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 10px;
}
</style>